module.exports = __webpack_public_path__ + "img/logo-smb-login.aa50d8ef.svg";